var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5068_71077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5C18 15.1579 15.5374 17.3125 12.5 17.3125C11.9552 17.3137 11.4127 17.243 10.8864 17.1021C10.4849 17.3056 9.563 17.6961 8.012 17.9505C7.8745 17.9725 7.77 17.8295 7.82431 17.7016C8.06769 17.1269 8.28769 16.361 8.35369 15.6625C7.5115 14.8169 7 13.71 7 12.5C7 9.84212 9.46262 7.6875 12.5 7.6875C15.5374 7.6875 18 9.84212 18 12.5ZM11.9459 11.6516C11.9005 11.584 11.8482 11.5214 11.7898 11.4646C11.6976 11.3704 11.5881 11.2948 11.4674 11.2419L11.4619 11.2391C11.299 11.1638 11.1216 11.1249 10.9421 11.125C10.2835 11.125 9.75 11.6379 9.75 12.2711C9.75 12.9036 10.2835 13.4164 10.9421 13.4164C11.1779 13.4164 11.3973 13.3511 11.5822 13.2377C11.488 13.5051 11.3141 13.7904 11.0253 14.0764C10.9981 14.103 10.9766 14.1348 10.9622 14.17C10.9478 14.2051 10.9407 14.2429 10.9414 14.2809C10.9421 14.3189 10.9506 14.3563 10.9663 14.3909C10.9821 14.4255 11.0047 14.4565 11.0329 14.4821C11.1518 14.5921 11.3402 14.5886 11.455 14.4752C12.3721 13.5615 12.3969 12.5791 12.1019 11.9273C12.0585 11.831 12.0062 11.739 11.9459 11.6523V11.6516ZM14.5625 13.2377C14.469 13.5051 14.2944 13.7904 14.0056 14.0764C13.9785 14.103 13.957 14.1349 13.9427 14.1701C13.9283 14.2053 13.9213 14.243 13.9221 14.281C13.9228 14.319 13.9314 14.3565 13.9472 14.391C13.963 14.4256 13.9857 14.4566 14.0139 14.4821C14.1321 14.5921 14.3205 14.5886 14.4353 14.4752C15.3524 13.5615 15.3772 12.5791 15.0829 11.9273C15.0393 11.831 14.9868 11.739 14.9262 11.6523C14.8809 11.5845 14.8286 11.5216 14.7701 11.4646C14.6779 11.3704 14.5684 11.2948 14.4477 11.2419L14.4422 11.2391C14.2795 11.1639 14.1024 11.125 13.9231 11.125C13.2652 11.125 12.731 11.6379 12.731 12.2711C12.731 12.9036 13.2652 13.4164 13.9231 13.4164C14.1589 13.4164 14.3783 13.3511 14.5632 13.2377H14.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5068_71077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatQuote);
export default __webpack_public_path__ + "static/media/chat-quote.096a2d9f74cf58f70a37ac6f2a4f7510.svg";
export { ForwardRef as ReactComponent };